<div class="box-content rd-widget widget-{{widgetConfig.widgetId}} widgetSiteInformation widgetNoTopBorder widget-two-columns-one-gap-fifty-percent" *ngIf="(widgetData$ | async) as widgetData">
  <div class="table-part">
    <table class="widget-flex" style="height: 100%;" aria-hidden="true">
      <thead>
        <tr class="widget-ruller-flex">
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
        </tr>
      </thead>
      <tbody class="viewModeTbody">
        <tr class="light-grey-line">
          <td colspan="6"><widget-label [widget]="this" [fieldName]="'dcfStartDate'" [align]="'left'"></widget-label></td>
          <td colspan="10"><widget-value [align]="'right'">{{widgetData.dcfStartDate | rdLocalizedDate }} </widget-value></td>
        </tr>
        <tr class="white-line">
          <td colspan="6"><widget-label [widget]="this" [fieldName]="'dcfHoldingPeriod'" [align]="'left'"></widget-label></td>
          <td colspan="10"><widget-value [align]="'right'">{{(  (widgetData.dcfHoldingPeriod || 0) | rdLocalizedNumber:0 )}}</widget-value></td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="space-part">&nbsp;</div>
</div>
